/** Local (browser) UI preferences, persisted in localStorage. */

const LOAD_EXTERNAL_IMAGES = 'zwf.loadExternalImages';

/** Load remote images in email bodies. Default: true (load). */
export function getLoadExternalImages(): boolean {
  return localStorage.getItem(LOAD_EXTERNAL_IMAGES) !== 'false';
}

export function setLoadExternalImages(value: boolean): void {
  localStorage.setItem(LOAD_EXTERNAL_IMAGES, value ? 'true' : 'false');
}
